import { Accordion, Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const CandidateProfileBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'calc(100% - 320px - 24px)', // gap = 24px, menuWidth = 270px
    minHeight: 'calc(100vh - 250px)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.white,
    borderRadius: '24px',
    padding: '24px', // need to be 32px

    [theme.breakpoints.down('laptop')]: {
      width: '100%',
    },

    [theme.breakpoints.down('tablet')]: {
      minHeight: 'calc(100vh - 136px)',
      width: '100%',
      gap: '4px',
      padding: '8px 0 0 0',
    },
  };
});

export const JobPostCardPreviewMainBlockHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    marginBottom: '32px',
  };
}) as typeof Box;

export const JobPostCardPreviewMainBlockHeaderTitle = styled(Typography)(
  ({ theme }: { theme: Theme }) => {
    return {
      color: palette.text.header,
      fontWeight: 700,
      fontSize: '48px',
      lineHeight: '61px',
    };
  }
) as typeof Typography;

export const JobPostCardPreviewMainBlockHeaderCompanyInfo = styled(Box)(
  ({ theme }: { theme: Theme }) => {
    return {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      flexWrap: 'wrap',
    };
  }
) as typeof Box;

export const JobPostCardPreviewMainBlockHeaderCompanyInfoLeft = styled(Box)(
  ({ theme }: { theme: Theme }) => {
    return {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    };
  }
) as typeof Box;

export const CompanyInfoLeftBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };
}) as typeof Box;

export const CompanyInfoLeftBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21px',
  };
}) as typeof Typography;

export const CompanyInfoLeftBlockSubTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.body,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
  };
}) as typeof Typography;

export const JobInfoBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  };
}) as typeof Box;

export const JobInfoBlockItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    padding: '12px',
    borderRadius: '12px',
    backgroundColor: palette.background.general,

    '> p': {
      color: palette.text.header,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21px',

      '> span': {
        fontWeight: 600,
      },
    },
  };
}) as typeof Box;

export const JobSummaryContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    padding: '32px 0 32px 0',
    gridTemplateColumns: '1fr 2fr',
    gap: '16px',
    alignItems: 'stretch',
    borderBottom: '1px solid #D8DBE8',

    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: '1fr',
    },
  };
}) as typeof Box;

export const JobSummaryTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
  };
}) as typeof Box;

export const JobSummaryContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    background: '#F3F9EE',
    borderRadius: '24px',
    padding: '20px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
  };
}) as typeof Box;

export const JobSummaryContentItemBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    minWidth: '200px',
    width: 'calc(50% - 12px)',
    gap: '12px',

    svg: {
      flexShrink: 0,
    },
  };
}) as typeof Box;

export const JobSummaryContentItemTextBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  };
}) as typeof Box;

export const JobSummaryContentItemTextBoxTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.body,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px',
  };
}) as typeof Box;

export const JobSummaryContentItemTextBoxSubTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '21px',
    letterSpacing: '0%',
  };
}) as typeof Box;

export const JobDetailsContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    padding: '32px 0 32px 0',
    gridTemplateColumns: '1fr 2fr',
    gap: '16px',
    alignItems: 'stretch',
    borderBottom: '1px solid #D8DBE8',

    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: '1fr',
    },
  };
}) as typeof Box;

export const JobDetailsTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
  };
}) as typeof Box;

export const JobDetailsContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  };
}) as typeof Box;

export const JobDetailsContentQualifications = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };
}) as typeof Box;

export const JobDetailsContentQualificationsItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  };
}) as typeof Box;

export const JobDetailsContentQualificationsItemTitle = styled(Box)(
  ({ theme }: { theme: Theme }) => {
    return {
      color: palette.text.header,
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '21px',
    };
  }
) as typeof Box;

export const JobDetailsContentQualificationsItemBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    gap: '12px',
  };
}) as typeof Box;

export const JobDetailsContentQualificationsItemBoxImportance = styled(Box)(
  ({ theme }: { theme: Theme }) => {
    return {
      display: 'flex',
      gap: '2px',

      '> div': {
        width: '10px',
        display: 'flex',
        justifyContent: 'center',
      },
    };
  }
) as typeof Box;

export const JobDetailsContentQualificationsItemBoxName = styled(Typography)(
  ({ theme }: { theme: Theme }) => {
    return {
      color: palette.text.header,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '22px',
    };
  }
) as typeof Typography;

export const ReusableTextBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };
}) as typeof Box;

export const ReusableTextBlockTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '31px',
  };
}) as typeof Typography;

export const ReusableTextBlockDesc = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.text.body,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    whiteSpace: 'pre-line',
  };
}) as typeof Typography;

export const CompanyContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    padding: '32px 0 32px 0',
    gridTemplateColumns: '1fr 2fr',
    gap: '16px',
    alignItems: 'stretch',
    borderBottom: '1px solid #D8DBE8',

    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: '1fr',
    },
  };
}) as typeof Box;

export const CompanyTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
  };
}) as typeof Box;

export const CompanyContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  };
}) as typeof Box;

export const ApplicationProcessContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    padding: '32px 0 32px 0',
    gridTemplateColumns: '1fr 2fr',
    gap: '16px',
    alignItems: 'stretch',

    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: '1fr',
    },
  };
}) as typeof Box;

export const ApplicationProcessTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
  };
}) as typeof Box;

export const ApplicationProcessContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  };
}) as typeof Box;

export const FAQContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'grid',
    padding: '32px 0 32px 0',
    gridTemplateColumns: '1fr 2fr',
    gap: '16px',
    alignItems: 'stretch',
    borderBottom: '1px solid #D8DBE8',

    [theme.breakpoints.down('tablet')]: {
      gridTemplateColumns: '1fr',
    },
  };
}) as typeof Box;

export const FAQTitle = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: palette.text.header,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38px',
  };
}) as typeof Box;

export const FAQContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  };
}) as typeof Box;

export const FAQWrapper = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '8px',
}) as typeof Box;

export const CustomAccordion = styled(Accordion)({
  borderRadius: '12px',
  backgroundColor: palette.background.blue500,
  boxShadow: 'none',
  border: 'none',

  '&.Mui-expanded': {
    margin: 0,
  },

  '.MuiButtonBase-root': {
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
  },

  '.MuiAccordionSummary-content': {
    margin: '18px 0',

    '&.Mui-expanded': {
      margin: '18px 0',
    },
  },

  '.MuiSvgIcon-root': {
    fill: palette.primary.purple500,
  },

  '.MuiAccordionDetails-root': {
    padding: '0 48px 20px 16px',
    textAlign: 'justify',
  },

  '&::before': {
    display: 'none',
  },

  '&:first-of-type': {
    borderRadius: '12px',
  },

  '&:last-of-type': {
    borderRadius: '12px',
  },
});

export const AccordionTitle = styled(Typography)({
  color: palette.text.header_unknown,
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '20.48px',
  letterSpacing: '0%',
}) as typeof Typography;

export const AccordionDesc = styled(Typography)({
  color: palette.text.body,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '19.04px',
  letterSpacing: '0%',
}) as typeof Typography;

export const Footer = styled(Box)({
  display: 'flex',
  backgroundColor: palette.background.general,
  padding: '32px',
  borderRadius: '24px',
  marginTop: '40px',
}) as typeof Box;

export const MatchScoreContainer = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '20px',
    backgroundColor: '#F3F6FF',
    padding: '20px 32px',
    borderRadius: '24px',
    margin: '20px 0',

    [theme.breakpoints.down('tablet')]: {
      flexDirection: 'column',
    },
  };
}) as typeof Box;

export const MatchScoreText = styled(Typography)({
  color: palette.text.header,
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '130%',
}) as typeof Typography;
